import React from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {Navigate} from 'react-router-dom';

import {I18n} from '@aws-amplify/core';

import ChangePasswordForm from '../forms/ChangePasswordForm';

import {changePassword} from '../reducers/recordsSlice';

import {changePasswordResultSelector} from '../selectors';

import {ErrorMessageComponent} from 'features/error-messages/hoc/ErrorMessageComponent';

import {useErrorMessage} from 'hooks/useErrorMessage';

import {Box, SimpleGrid} from '@mantine/core';

import {useAccount} from 'hooks/useAccount';

import {useAuth} from 'hooks/useAuth';

export const IndexPage = () => {
    const dispatch = useDispatch();

    const errorMessage = useErrorMessage();

    const account = useAccount();

    const { user, profile, session } = useAuth({ account });

    const changePasswordResult = useSelector((state) =>
        changePasswordResultSelector(state)
    );

    const handleSubmit = (values) => {
        dispatch(
            changePassword({ account, user, password: values.new_password })
        );
    };

    if (changePasswordResult === 'success') {
        return <Navigate to="/" />;
    }

    if (errorMessage) {
        return <ErrorMessageComponent error={errorMessage} />;
    }

    return (
        <SimpleGrid>
            <Box variant="h2">{I18n.get('Change Password')}</Box>
            <Box>{I18n.get('to continue to')} NEXT Cloud</Box>
            <Box mt="sm">
                <ChangePasswordForm handleSubmit={handleSubmit} />
            </Box>
        </SimpleGrid>
    );
};
